import React, { useCallback } from 'react';

const Footer = ({ t, language, setLanguage, scrollToSection }) => {
  const handleLogoClick = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const languages = ['cs', 'en'];

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content-desktop">
        {/* Column 1: Large Logo */}
        <div className="footer-column footer-logo-column">
          <img 
            src="https://customer-assets.emergentagent.com/job_urban-cage-landing/artifacts/encpbcm8_LOGO_Footer.svg" 
            alt="UrbanCage Logo" 
            className="footer-logo-large"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer' }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter') handleLogoClick(); }}
            data-testid="footer-logo"
          />
        </div>
        
        {/* Column 2: Navigation */}
        <div className="footer-column footer-nav-column-wide">
          <h4>{t.footerNav}</h4>
          <nav className="footer-nav-columns" aria-label="Footer navigation">
            <div className="footer-nav-column">
              <button onClick={() => scrollToSection('intro')} data-testid="footer-nav-intro">{t.whatIsUrbanCage}</button>
              <button onClick={() => scrollToSection('who-for')} data-testid="footer-nav-who-for">{t.whoForTitle}</button>
              <button onClick={() => scrollToSection('patented')} data-testid="footer-nav-patented">{t.patentedTitle}</button>
              <button onClick={() => scrollToSection('models')} data-testid="footer-nav-models">{t.modelSizeTitle}</button>
            </div>
            <div className="footer-nav-column">
              <button onClick={() => scrollToSection('gallery')} data-testid="footer-nav-gallery">{t.galleryTitle}</button>
              <button onClick={() => scrollToSection('video')} data-testid="footer-nav-video">{t.videoTitle}</button>
              <button onClick={() => scrollToSection('contact')} data-testid="footer-nav-contact">{t.contactTitle}</button>
            </div>
          </nav>
        </div>

        {/* Column 3: Contact & Language */}
        <div className="footer-column footer-contact-column">
          <h4>{t.contactTitle}</h4>
          <div className="footer-contact">
            <a href={`mailto:${t.email}`} data-testid="footer-email-link">{t.email}</a>
            <a href={`tel:${t.phone}`} data-testid="footer-phone-link">{t.phone}</a>
          </div>
          <div className="footer-language" role="group" aria-label="Footer language selector">
            {languages.map((lang) => (
              <button
                key={`footer-lang-${lang}`}
                className={`footer-lang-btn ${language === lang ? 'active' : ''}`}
                onClick={() => setLanguage(lang)}
                aria-pressed={language === lang}
                data-testid={`footer-lang-btn-${lang}`}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>{t.footerCopyright}</p>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
